/**
 * Marca, na sessão do navegador, que a visita chegou pelo link da AdvancedBR
 * (`utm_source=advancedbr`). Os botões de download do app só pedem o e-mail
 * nessas visitas; nas demais, abrem a loja direto.
 *
 * Lida em `src/index.tsx`, antes do primeiro render: o `URLRedirectHandler`
 * reescreve a URL das páginas de busca e levaria o `utm_source` junto.
 */
const CAMPAIGN_VISIT_KEY = "campaign_visit";
const ADVANCEDBR = "advancedbr";

export function rememberCampaignVisit(search: string): void {
  const source = new URLSearchParams(search).get("utm_source");
  if (source?.toLowerCase() !== ADVANCEDBR) return;

  try {
    sessionStorage.setItem(CAMPAIGN_VISIT_KEY, ADVANCEDBR);
  } catch (error) {
    console.warn("⚠️ Não foi possível marcar a visita da campanha:", error);
  }
}

export function isAdvancedbrVisit(): boolean {
  try {
    return sessionStorage.getItem(CAMPAIGN_VISIT_KEY) === ADVANCEDBR;
  } catch {
    return false;
  }
}
